import React from 'react';
import Icon from '../common/Icon'; // Added import for consistency

const TrialExpiredModal = ({ isOpen, onClose, onViewPlans }) => {
  if (!isOpen) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 p-4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 w-full max-w-sm max-h-[90vh] overflow-y-auto text-center">
        <span className="text-6xl mb-4"><Icon name="hourglass" /></span> {/* Replaced hardcoded emoji with Icon component */}
        <h2 className="text-2xl font-extrabold mb-2">Your Free Trial Has Ended</h2>
        <p className="text-gray-600 mb-6">
          We hope you enjoyed your first steps! Subscribe now to unlock unlimited access to all lessons, interactive games, cultural stories, and fun activities to continue your language journey.
        </p>
        <button
          onClick={onViewPlans}
          className="w-full bg-green-500 text-white font-bold py-3 rounded-xl mb-3 transition active:scale-95"
        >
          View Subscription Plans
        </button>
        <button
          onClick={onClose}
          className="w-full text-gray-600 font-bold py-2"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
